import { render } from "./HealthInfo.vue?vue&type=template&id=2b59c404"
const script = {}

import "./HealthInfo.vue?vue&type=style&index=0&id=2b59c404&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__